// extracted by mini-css-extract-plugin
module.exports = {"unit":"Unit_unit__zkcZZ","unit--small":"Unit_unit--small__gzJPn"};